module.exports = __webpack_public_path__ + "static/towTruck-5bc9ea4387e9fe1741cd4172e27a9274.png";